import type { ApiConfig } from '../declare'

const apis: ApiConfig[] = [
  {
    name: 'getByRedis',
    method: 'GET',
    path: '/OP/Form/GetByRedis',
    params: {
      Key: '',
      OrgId: ''
    },
    desc: '获取表单配置'
  },
  {
    name: 'getCustomPageConfigInfo',
    method: 'POST',
    path: '/OP/PageCustom/GetCustomPageConfigInfo',
    params: {
      Keyword: '',
      OrgId: ''
    },
    desc: '获取自定义表单配置'
  },
  {
    name: 'getDataByPost',
    method: 'POST',
    path: '/',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '自定义URL请求的POST方法'
  },
  {
    name: 'getDataByGet',
    method: 'GET',
    path: '/',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '自定义URL请求的GET方法'
  },
  {
    name: 'genSystemCode',
    method: 'POST',
    path: '/PF/CodeRule/GenSystemCode',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '生成系统序列号'
  },
  {
    name: 'getRedisValue',
    method: 'POST',
    path: '/PF/Redis/GetValue',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '获取缓存值'
  },
  {
    name: 'setRedisValue',
    method: 'POST',
    path: '/PF/Redis/SetValue',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '设置缓存值'
  },
  {
    name: 'getEnums',
    method: 'GET',
    path: '/OP/Extend/GetEnums',
    params: {
      EnumNames: ''
    },
    axiosOptions: {
      noAttachedData: true
    },
    desc: '获取枚举'
  },
  {
    name: 'generateSignature',
    method: 'POST',
    path: '/ENT/User/GenerateSignature',
    params: {},
    axiosOptions: {},
    desc: '生成应用间跳转签名'
  },
  {
    name: 'generateToken',
    method: 'POST',
    path: '/ENT/User/GenerateToken',
    params: {
      Signature: '',
    },
    axiosOptions: {},
    desc: '目标应用根据签名生成token'
  },
  {
    name: 'getTenantCode',
    method: 'POST',
    path: '/ENT/Login/GetTenantCode',
    params: {
      VisitCode: '',
    },
    axiosOptions: {
      noAttachedData: true
    },
    desc: '租户编码'
  },
  {
    name: 'getVersion',
    method: 'GET',
    path: '/OP/AppVersion/GetLastVersion',
    params: {},
    axiosOptions: {},
    desc: '获取版本号'
  },
  {
    name: 'getServerTime',
    method: 'GET',
    path: '/CFG/Machine/GetCurrentTime',
    params: {},
    axiosOptions: {},
    desc: '获取服务器时间'
  },
  {
    name: 'getImportConfig',
    method: 'POST',
    path: '/FM/ImportConfig/GetImportConfig',
    params: {},
    axiosOptions: { fullData: true },
    desc: '获取导入配置'
  }
]

export default apis